var Login;
(function (Login) {
    var Controller = (function () {
        function Controller() {
            this.errorValidation = new ErrrorValidation.Controller();
            var parentEmailForgot = $('.formContent');
            this.emailInputWrapper = parentEmailForgot.find($('.inputWrapper'));
            this.emailLabelElement = parentEmailForgot.find($('.labelForInput'));
            var parentLogin = $('#loginForm');
            this.inputWrapper = parentLogin.find('.inputWrapper');
            this.loginLabel = parentLogin.find('.labelForInput');
            this.tokenIsValid = $('.tokenIsValid').val();

            var _this = this;
            for (var i = 0; i < _this.emailLabelElement.length; i++) {
                _this.errorValidation.StoreOldLabel($(_this.emailLabelElement[i]).attr('id'), $(_this.emailLabelElement[i]).text());
            }

            $('form').submit(function () {
                return false;
            });
            $('#loginForm input').keypress(function (e) {
                if (e.keyCode === 13 && $('#loginForm').length > 0) {
                    _this.DoLogin();
                }
            });

            $("input").on('input', function () {
                $('input[name="' + this.name + '"]').val($(this).val());
            });

            $('.close-login-error-box').on('click', function () {
                _this.SlideUpForgotPassword();
                _this.HideLoginError();
            });

            $('.close-reset-password-response').on('click', function () {
                if ($(".forgotPasswordWrapperSlide .slideUp").is(':visible')) {
                    _this.HideLoginError();
                    _this.SlideDownForgotPassword();
                } else {
                    _this.SlideUpForgotPassword();
                    _this.errorValidation.SuccessShowHide('active', 'inactive');
                    _this.errorValidation.FailedShowHide('active', 'inactive');
                }
            });

            if (_this.tokenIsValid === "0") {
                _this.errorValidation.FailedShowHide('inactive', 'active');
                $('.successWrapper').addClass('active');
            }
            $('#submitResetPassword').click(function () {
                var password = $('#resetPasswordForm').find("[name='password']");
                var passwordVerified = $('#resetPasswordForm').find("[name='passwordVerified']");
                if (!inputValidator.IsNotEmpty(password.val()) || !inputValidator.IsNotEmpty(passwordVerified.val())) {
                    var passwordMustNotBeEmpty = $("[name='PasswordMustNotBeEmpty']");
                    _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, passwordMustNotBeEmpty.val());
                    return false;
                }
                if (!inputValidator.DoesMatch(password.val(), passwordVerified.val())) {
                    var passwordDoesNotMatch = $("[name='PasswordDoesNotMatch']");
                    _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, passwordDoesNotMatch.val());
                    return false;
                }
                helperController.AjaxHelper('DoResetPassword', 'json', $('#resetPasswordForm').serialize(), 'POST',
                    function success(data) {
                        if (data.isValid && data.isDone) {
                            _this.errorValidation.ResetAll(_this.emailInputWrapper, _this.emailLabelElement, true);
                            _this.errorValidation.SuccessShowHide('inactive', 'active');
                            $('.successWrapper').addClass('active');

                            setTimeout(function () {
                                if ($('#successUrl').length) {
                                    window.location.href = $('#successUrl').attr('href');
                                } else {
                                    window.location.href = '/';
                                }
                            }, 5000);
                        } else {
                            _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, data.message);
                        }
                    },
                    function failed(data) {
                        _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, data.message);
                        _this.errorValidation.FailedShowHide('inactive', 'active');
                        $('.successWrapper').addClass('active');
                    });
            });

            $('#submitSendEmail').on('click', function () {
                var emailInput = _this.emailInputWrapper.find('.inputBox').val();
                if (!inputValidator.IsValid(emailInput, 100)) {
                    var notAValidEmail = $("[name='notAValidEmail']");
                    _this.errorValidation.ResetAll(_this.emailInputWrapper, _this.emailLabelElement, false);
                    _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, notAValidEmail.val());
                    return false;
                }
                helperController.AjaxHelper('ResetByEmail', 'json', 'Email=' + emailInput, 'POST',
                    function success(data) {
                        if (data.isValid && data.isDone) {
                            _this.errorValidation.ResetAll(_this.emailInputWrapper, _this.emailLabelElement, true);
                            _this.errorValidation.SuccessShowHide('inactive', 'active');
                        } else {
                            _this.errorValidation.ResetAll(_this.emailInputWrapper, _this.emailLabelElement, false);
                            _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, data.message);
                        }
                    },
                    function failed(data) {
                        _this.errorValidation.ResetAll(_this.emailInputWrapper, _this.emailLabelElement, false);
                        _this.errorValidation.FailedShowHide('inactive', 'active');
                    });
            });

            $(".forgotPasswordIconWrapper, .forgotpasswordtext").click(function () {
                if ($(".forgotPasswordWrapperSlide .slideUp").is(':visible')) {
                    _this.HideLoginError();
                    _this.SlideDownForgotPassword();
                } else {
                    _this.SlideUpForgotPassword();
                    _this.errorValidation.SuccessShowHide('active', 'inactive');
                    _this.errorValidation.FailedShowHide('active', 'inactive');
                }
            });

            $('.submitLogin').click(function () {
                _this.DoLogin();
            });
        }

        Controller.prototype.DoLogin = function () {
            var _this = this;
            var username = $('#loginForm').find("[name='username']");
            var password = $('#loginForm').find("[name='password']");
            if (!inputValidator.IsValid(username.val(), 50) || !inputValidator.IsValid(password.val(), 50)) {
                _this.errorValidation.AddError(_this.inputWrapper, _this.loginLabel, "");
                _this.SlideUpForgotPassword();
                _this.errorValidation.SuccessShowHide('active', 'inactive');
                _this.errorValidation.FailedShowHide('active', 'inactive');
                _this.ShowLoginError();
                return false;
            }
            helperController.AjaxHelper('LogIn', 'json', $('#loginForm').serialize(), 'POST',
            function success(data) {
                if (data.isValid && data.isDone) {
                    if ($('input[name="ReturnUrl"]').length) {
                        window.location.href = $('input[name="ReturnUrl"]').val();
                    } else {
                        window.location.href = "/";
                    }
                } else {
                    _this.errorValidation.AddError(_this.inputWrapper, _this.loginLabel, data.message);
                    _this.SlideUpForgotPassword();
                    _this.errorValidation.SuccessShowHide('active', 'inactive');
                    _this.errorValidation.FailedShowHide('active', 'inactive');
                    _this.ShowLoginError();
                }
            },
            function failed(data) {
                _this.errorValidation.AddError(_this.inputWrapper, _this.loginLabel, data.message);
                _this.SlideUpForgotPassword();
                _this.errorValidation.SuccessShowHide('active', 'inactive');
                _this.errorValidation.FailedShowHide('active', 'inactive');
                _this.ShowLoginError();
            });
        }

        Controller.prototype.ShowLoginError = function () {
            var _this = this;
            var element = $('.loginError');
            element.removeClass('inactive');
            element.addClass('active');
        }

        Controller.prototype.HideLoginError = function () {
            var _this = this;
            var element = $('.loginError');
            element.removeClass('active');
            element.addClass('inactive');
            var input = _this.inputWrapper.find('.inputError');
            input.removeClass('inputError');
            _this.loginLabel.removeClass('labelError');
            var icon = _this.inputWrapper.find('i');
            icon.hide();
        }

        Controller.prototype.SlideDownForgotPassword = function () {
            $(".forgotPasswordWrapper").removeClass("slideUp").addClass("slideDown");
            $(".forgotPasswordWrapperSlide").removeClass("slideUp").addClass("slideDown");
            $('.forgotPassword').addClass('active');
            $('.forgotPasswordIcon').removeClass('inactiveIcon').addClass('active');
        }

        Controller.prototype.SlideUpForgotPassword = function () {
            var _this = this;
            $(".forgotPasswordWrapper").removeClass("slideDown").addClass("slideUp");
            $(".forgotPasswordWrapperSlide").removeClass("slideDown").addClass("slideUp");
            $('.forgotPassword').removeClass('active');
            $('.forgotPasswordIcon').removeClass('active').addClass('inactiveIcon');
            _this.errorValidation.ResetAll(_this.emailInputWrapper, _this.emailLabelElement, true);
        }
        return Controller;
    })();
    Login.Controller = Controller;
})(Login || (Login = {}));
$(function () {
    new Login.Controller();
})